/*
 * @Author: hanhuixian hanhuixian@lxrental.com
 * @Date: 2023-08-23 11:01:33
 * @LastEditors: hanhuixian hanhuixian@lxrental.com
 * @LastEditTime: 2023-08-23 11:01:33
 * @Description: 公共组件、模块相关所涉及的上报埋点数据方法
 */

import rentGo from "@/tools/rentGo";

export default {
	// 切换简、繁、英语言
	changLanguage(properties, event) {
		rentGo.pageClick({
			event,
			biz: "chang_language",
			properties,
		});
	},
	// 打印页面
	// printPage(properties, event) {
	// 	rentGo.pageClick({
	// 		event,
	// 		biz: "print_page",
	// 		properties,
	// 	});
	// },
}